export const VALID_LOCATIONS_ADMIN: Array<string> = ['review', 'article', 'employee', 'landingpage', 'product', 'category', 'shoplocation', 'logout', 'order', 'points'];

export const VALID_LOCATIONS_WAITER = ['order', 'logout'];
